<!-- App.vue -->
<template>
  <div>
    <router-view/>
    <GlobalNotify :info="notifyInfo" :visible="notifyVisible"/>
  </div>
</template>

<script>
import GlobalNotify from '@/components/GlobalNotify.vue'
import {connectMqtt} from '@/utils/mqtt'
import {notifyBus, notifyStore, AUDIO_MAP} from '@/utils/notify'

export default {
  name: 'App',
  components: {GlobalNotify},
  data() {
    return {
      notifyQueue: [],
      notifyInfo: {},
      notifyVisible: false,
      isNotifying: false,
      timer: null,
    }
  },
  created() {
    // 1. 连接MQTT推送
    let userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
    let testtoken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6NjAzMjY1LCJpYXQiOjE3NjI3NjM0MzEsImV4cCI6MTc2Mjg0OTgzMX0.FAPX-Jmj3hBsib2Oyn2A5coYrm1kyJB5oc45NMBm94w'
    let molv_token = localStorage.getItem('molv_token')
    let userId =  userInfo.id
    console.log('连接MQTT推送', userId, molv_token)
    if (userId && molv_token) {
      const client = connectMqtt(userId, molv_token)
      client.on('message', (topic, message) => {
        try {
          let {msgType, info} = JSON.parse(message.toString())
          notifyBus.$emit('push', {msgType, info})
          console.log('MQTT消息接收', msgType, JSON.stringify(info))
        } catch (e) {
          console.warn('MQTT消息解析失败', message.toString(), e)
        }
      })
    }
    // 2. 监听全局推送队列
    notifyBus.$on('push', this.enqueue)
  },
  beforeDestroy() {
    notifyBus.$off('push', this.enqueue)
    clearTimeout(this.timer)
  },
  methods: {
    enqueue(data) {
      this.notifyQueue.push(data)
      this.showNext()
    },
    showNext() {
      if (this.isNotifying || !notifyStore.show || this.notifyQueue.length === 0) return
      const data = this.notifyQueue.shift()
      const typeCfg = notifyStore.types[data.msgType] || {show: true, audioOn: true}
      if (!typeCfg.show) {
        this.isNotifying = false
        this.showNext()
        return
      }
      this.isNotifying = true
      this.notifyInfo = {...data.info, msgType: data.msgType}
      this.notifyVisible = true

      // 播放音效
      if (notifyStore.audioOn && typeCfg.audioOn) {
        let audioPath = AUDIO_MAP[data.msgType] || '/Default.mp3'
        const audio = new Audio(audioPath)
        audio.currentTime = 0
        audio.play().catch(() => {})
      }

      // 根据 msgType 动态设置弹窗时长
      let duration = 2000
      if (data.msgType === '用户下单') duration = 30000  // 30秒
      if (data.msgType === '陪玩_准备下单') duration = 15000 // 15秒
      if (data.msgType === '城市合作') duration = 20000     // 20秒（新加）

      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.notifyVisible = false
        setTimeout(() => {
          this.isNotifying = false
          this.showNext()
        }, 300)
      }, duration)
    }
  }
}
</script>

<style>
/* 数据大屏全屏模式：隐藏左侧菜单，内容区铺满 */
.data-screen-fullscreen .el-aside {
  display: none !important;
}
.data-screen-fullscreen .el-main {
  padding: 0 !important;
}
</style>
